import { useEffect, useState, useCallback } from 'react'
import { Row } from 'react-table'

export type PatientData = {
  _id: string
  name: string
  surname: string
  gender?: 'M' | 'F' | 'I' | 'O'
  birthday?: string
  city?: string
  secu: string
}

interface UsePatientsTableSelectionParams {
  rows: Row<PatientData>[]
  autoHightlight?: boolean
  disableSelectRow?: boolean
  selectedIds?: (string | null)[]
  onSelect?: (data: PatientData) => void
}

export function usePatientsTableSelection({
  rows,
  autoHightlight = true,
  disableSelectRow = false,
  selectedIds,
  onSelect,
}: UsePatientsTableSelectionParams) {
  const [selectedRow, setSelectedRow] = useState<string>()

  useEffect(() => {
    if (!selectedIds && autoHightlight && selectedRow === undefined && !!rows.length && !disableSelectRow) {
      setSelectedRow(rows[0].original._id)
    }
  }, [selectedIds, autoHightlight, disableSelectRow, rows, selectedRow])

  const selectRow = useCallback(
    (row: Row<PatientData>) => {
      if (disableSelectRow) return
      setSelectedRow(row.original._id)
      onSelect?.(row.original)
    },
    [disableSelectRow, onSelect]
  )

  const isRowSelected = useCallback(
    (rowId: string) => {
      return selectedIds ? selectedIds.includes(rowId) : selectedRow === rowId
    },
    [selectedIds, selectedRow]
  )

  return {
    selectedRow,
    selectRow,
    isRowSelected,
  }
}
